module.exports = __webpack_public_path__ + "img/shopCart.d10e9db7.png";